import * as C from 'constants/Redux'
import * as P from 'constants/Permissions'
import { DEFAULT_COUNTRY } from 'constants/Countries'
import { SERVER_VERSION, TOKEN_TYPE } from 'constants/Servers'

const PREFIX = 'CONFIG / '
const DEBUG = `${PREFIX}DEBUG`
const LANGUAGE = `${PREFIX}LANGUAGE`
const ACCOUNT = `${PREFIX}ACCOUNT`
const COUNTRY = `${PREFIX}COUNTRY`
const DIALER = `${PREFIX}DIALER`
const MODE = `${PREFIX}MODE`
const POSITION = `${PREFIX}POSITION`
const SIZE = `${PREFIX}SIZE`
const CND = `${PREFIX}CND`
// TODO SPOG remove when dialer version 2 will be ready
const CONSUMER = `${PREFIX}CONSUMER`

const CALLER_IDS = `${PREFIX}CALLER_IDS`
const SCALABLE = `${PREFIX}SCALABLE`
const SIZE_MODE = `${PREFIX}SIZE_MODE`
// setup
export const CONFIG_HYDRATE = `${PREFIX}HYDRATE`
export const MODE_SET = MODE + C.SET
// TODO SPOG remove when dialer version 2 will be ready
export const CONSUMER_SET = CONSUMER + C.SET
export const POSITION_SET = POSITION + C.SET
// TODO SPOG remove when dialer version 2 will be ready
export const SIZE_SET = SIZE + C.SET

export const SIZE_MODE_SET = SIZE_MODE + C.SET
export const SCALABLE_SET = SCALABLE + C.SET

// debug
export const DEBUG_FETCH = DEBUG + C.FETCH
export const DEBUG_UPDATE = DEBUG + C.UPDATE
export const DEBUG_CLEAR = DEBUG + C.CLEAR
export const DEBUG_TOGGLE = DEBUG + C.TOGGLE

// token type
export const TOKEN_TYPE_UPDATE = `${PREFIX}TOKEN_TYPE_UPDATE`

// language
export const LANGUAGE_UPDATE = LANGUAGE + C.UPDATE
export const LANGUAGE_UPDATE_FULFILLED = LANGUAGE_UPDATE + C.FULFILLED

// account
export const ACCOUNT_FETCH = ACCOUNT + C.FETCH
export const ACCOUNT_FETCH_PENDING = ACCOUNT_FETCH + C.PENDING
export const ACCOUNT_FETCH_FULFILLED = ACCOUNT_FETCH + C.FULFILLED
export const ACCOUNT_FETCH_REJECTED = ACCOUNT_FETCH + C.REJECTED

// cnd
export const CND_FETCH = CND + C.FETCH
export const CND_FETCH_PENDING = CND_FETCH + C.PENDING
export const CND_FETCH_FULFILLED = CND_FETCH + C.FULFILLED
export const CND_FETCH_REJECTED = CND_FETCH + C.REJECTED

// fetch caller ids
export const CALLER_ID_FETCH = CALLER_IDS + C.FETCH
export const CALLER_ID_FETCH_PENDING = CALLER_ID_FETCH + C.PENDING
export const CALLER_ID_FETCH_FULFILLED = CALLER_ID_FETCH + C.FULFILLED
export const CALLER_ID_FETCH_REJECTED = CALLER_ID_FETCH + C.REJECTED

// update caller ids
export const CALLER_ID_UPDATE = CALLER_IDS + C.UPDATE
export const CALLER_ID_UPDATE_PENDING = CALLER_ID_UPDATE + C.PENDING
export const CALLER_ID_UPDATE_FULFILLED = CALLER_ID_UPDATE + C.FULFILLED
export const CALLER_ID_UPDATE_REJECTED = CALLER_ID_UPDATE + C.REJECTED

// country
export const COUNTRY_CREATE = COUNTRY + C.CREATE
export const COUNTRY_UPDATE = COUNTRY + C.UPDATE

// permissions
export const MICROPHONE_PERMISSION_FETCH = `${PREFIX}MICROPHONE_PERMISSION${C.FETCH}`
export const MICROPHONE_PERMISSION_FETCH_PENDING =
  MICROPHONE_PERMISSION_FETCH + C.PENDING
export const MICROPHONE_PERMISSION_FETCH_FULFILLED =
  MICROPHONE_PERMISSION_FETCH + C.FULFILLED

export const NOTIFICATIONS_PERMISSION_FETCH = `${PREFIX}NOTIFICATIONS_PERMISSION${C.FETCH}`
export const NOTIFICATIONS_PERMISSION_FETCH_PENDING =
  NOTIFICATIONS_PERMISSION_FETCH + C.PENDING
export const NOTIFICATIONS_PERMISSION_FETCH_FULFILLED =
  NOTIFICATIONS_PERMISSION_FETCH + C.FULFILLED

export const PERMISSIONS_UPDATE = `${PREFIX}PERMISSIONS${C.UPDATE}`

// set dialer ready
export const DIALER_READY = `${DIALER}_READY`

export const SET_IS_SHOWN = `${PREFIX}IS_SHOWN${C.SET}`

export const ADD_SIP_ACTION = `${PREFIX}ADD_SIP_ACTION`
export const REMOVE_SIP_ACTION = `${PREFIX}REMOVE_SIP_ACTION`
export const REMOVE_ALL_SIP_ACTIONS = `${PREFIX}REMOVE_ALL_SIP_ACTIONS`

export const INITIAL_STATE = {
  servers: {},
  environment: 'QA',
  version: SERVER_VERSION.V2,
  language: 'en',
  tokenType: TOKEN_TYPE.JWT,
  debug: false,
  account: false,
  loading: false,
  error: false,
  country: DEFAULT_COUNTRY,
  permissions: {
    [P.MICROPHONE]: null,
    [P.NOTIFICATIONS]: null,
    microphonePermissionLoading: false,
    notificationsPermissionLoading: false,
  },
  ready: false,
  isShown: false,
  modeFloat: false,
  fullSize: false,
  position: false,
  callerIdsInfo: {
    list: [],
  },
  cnd: {
    loaded: false,
    loading: false,
    error: false,
    name: false,
    number: false,
  },
  is3wayEnabled: false,
  isWarmTransferEnabled: false,
  sipActions: [],
  isScalable: false,
}
